import './styles.scss';
import AutoFillingPropertyItem from '../AutoFillingPropertyItem';

const AutoFillingPropertiesSidebar = ({ onClose, autoFillingVariables, updateFormAutoFillingVariables }) => {
  return (
    <div className="form-builder-aside-property-open form-builder-aside-property auto-filling-variables-aside">
      <h2 className="form-builder-aside-property-title">
        Auto-Filling Properties
        <button className="btn btn-icon" onClick={onClose}>
          <i className="icon-icon-x"></i>
        </button>
      </h2>
      <div className="variables-list">
        {autoFillingVariables.map((variable, index) => (
          <AutoFillingPropertyItem
            variable={variable}
            key={`variable-${variable.name}-${index}`}
            updateFormAutoFillingVariables={updateFormAutoFillingVariables}
            autoFillingVariables={autoFillingVariables}
          />
        ))}
      </div>
    </div>
  );
};

export default AutoFillingPropertiesSidebar;
